export default __webpack_public_path__ + "media/images/theme/bg_dark-0387e9bc4de0345813c96fe8592ad042.png";